<template lang="pug">
.show-md.btn.btn-action.btn-primary.s-circle(
  v-if='!loading && user',
  @click='copyFiliationURL'
)
  i.fas.fa-clipboard
</template>

<script>
import env from '@/config/env'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('auth', ['user', 'loading']),

    filiationURL() {
      const url = env.storeURL
      return `${url}?filiation=${this.user.filiation.code}`
    },
  },

  methods: {
    async copyFiliationURL() {
      await navigator.clipboard.writeText(this.filiationURL)
      this.$toaster.success('Link copiado')
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn
  position fixed
  bottom 50px
  right 30px
</style>
